/**
 * O telefone de uma Pessoa como a tela o mostra (13.4) — a tela Pessoas e, desde a 13.19c1, a
 * sugestão de Pessoas da ficha nova.
 *
 * Mora fora de `ListaDePessoas.tsx` porque a ficha nova (`PessoasDaFichaNova.tsx`) o usa, e a tela
 * Pessoas importa a ficha nova (pelo modal da Empresa nova): importá-lo de lá fecharia um ciclo.
 */

import { formatarNumeroDeWhatsapp } from '@/modulos/comunicacao/contexto-da-conversa'
import { formatarTelefone } from '@/telefone/mascara-do-telefone'

/** O telefone vazio na linha da tela Pessoas. */
const VAZIO = '—'

/**
 * O telefone como a tela o mostra: a grafia da ficha (13.2) e, quando ela não formata — o número
 * cru do provedor que a Pessoa solta carrega (`5522997550997`) —, a do WhatsApp (`+55 22 99755-0997`).
 */
export function telefoneNaTela(telefone: string | null): string {
  if (telefone === null || telefone.trim() === '') {
    return VAZIO
  }
  const grafia = formatarTelefone(telefone)
  if (grafia !== telefone) {
    return grafia
  }
  // Só o número cru brasileiro do provedor (`55` + 10 ou 11 dígitos, sem nada em volta) ganha a
  // grafia do WhatsApp: um fixo de oito dígitos, um 0800 ou um texto livre ficam como foram escritos
  // — o `+` na frente deles seria um DDI que ninguém digitou.
  return /^55\d{10,11}$/.test(telefone.trim()) ? formatarNumeroDeWhatsapp(telefone) : telefone
}
